import { Component } from '@angular/core';
import {IncomeTaxEntity} from "@snelstart-ventures/fiscaal/domain-logic";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-box3-sparen-en-beleggen',
  templateUrl: './box3-sparen-en-beleggen.component.html',
  styleUrls: ['./box3-sparen-en-beleggen.component.scss'],
})
export class Box3SparenEnBeleggenComponent {

    public incomeTaxEntity = {} as IncomeTaxEntity;

    public banken = true;
    public beleggingen = false;
    public leningen = false;
    public overigeBezittingen = false;
    public onroerendeZaken = false;

    public activeButtonId = "Banken";

    public bankenTrue() {
        this.banken = true;
        this.beleggingen = false;
        this.overigeBezittingen = false;
        this.onroerendeZaken = false;
        this.leningen = false;
        this.activeButtonId = "Banken";
    }
    public beleggingenTrue() {
        this.banken = false;
        this.beleggingen = true;
        this.overigeBezittingen = false;
        this.onroerendeZaken = false;
        this.leningen = false;
        this.activeButtonId = "Beleggingen";
    }
    public onroerendeZakenTrue() {
        this.banken = false;
        this.beleggingen = false;
        this.overigeBezittingen = false;
        this.onroerendeZaken = true;
        this.leningen = false;
        this.activeButtonId = "OnroerendeZaken";
    }
    public overigeBezittingenTrue() {
        this.banken = false;
        this.beleggingen = false;
        this.overigeBezittingen = true;
        this.onroerendeZaken = false;
        this.leningen = false;
        this.activeButtonId = "Overig";
    }
    public schuldenTrue() {
        this.banken = false;
        this.beleggingen = false;
        this.overigeBezittingen = false;
        this.onroerendeZaken = false;
        this.leningen = true;
        this.activeButtonId = "Schulden";
    }

}
